import React from "react";
import { motion } from "framer-motion";
import "../../components/Work/Work.css";
import "../../styles/CustomClassCss/Custom.css";

import registrationIcon from "../../assets/images/svg/how_to_reg.svg";
import browseIcon from "../../assets/images/svg/mystery.svg";
import inquiriesIcon from "../../assets/images/svg/export_notes.svg";
import quotesIcon from "../../assets/images/svg/speaker_notes.svg";
import negotiationIcon from "../../assets/images/svg/partner_exchange.svg";
import paymentIcon from "../../assets/images/svg/work2.png";
import orderTrackingIcon from "../../assets/images/svg/work3.png";
import deliveryIcon from "../../assets/images/svg/work4.png";
import orderCompleteIcon from "../../assets/images/svg/work1.png";

const Work = () => {
	const steps = [
		{ icon: registrationIcon, title: "Registration", description: "  Download the app, create your profile, and start exploring." },
		{ icon: browseIcon, title: "Browse", description: "Buyers can browse a comprehensive range of steel and polymer products, while sellers can easily list their items for sale." },
		{ icon: inquiriesIcon, title: "Inquiries", description: "Interested buyers can send inquiries or request quotes directly to sellers." },
		{ icon: quotesIcon, title: "Quotes", description: "  Sellers respond with quotes, allowing buyers to compare multiple offers and choose the best deal." },
		{ icon: negotiationIcon, title: "Negotiation", description: "  Both buyers and sellers can negotiate terms, ensuring a mutually beneficial agreement." },
		{ icon: paymentIcon, title: "Payment & Banking Assistance", description: " Stelmart offers secure, bank-supported payment options, ensuring a safe transaction process within the app.(coming soon)" },
		{ icon: orderTrackingIcon, title: "Order Tracking", description: "Buyers receive real-time order tracking updates, keeping them informed every step of the way." },
		{ icon: deliveryIcon, title: "Delivery Updates", description: "  Sellers share timely delivery updates, ensuring smooth and transparent communication." },
		{ icon: orderCompleteIcon, title: "Order Complete", description: "Once delivered, the order status is updated as successfully completed, ensuring full satisfaction." },
	];

	const animationVariants = {
		odd: {
			hidden: { opacity: 0, y: 50 },
			visible: {
				opacity: 1,
				y: 0,
				transition: { duration: 2, ease: "easeInOut" },
			},
		},
		even: {
			hidden: { opacity: 0, y: -50 },
			visible: {
				opacity: 1,
				y: 0,
				transition: { duration: 2, ease: "easeInOut" },
			},
		},
	};

	return (
		<div className="work-container custom-container-upper custom-inner-space">
			<h2 className="work-title font-merriweather">HOW STELMART WORKS</h2>
			<p className="work-subtitle font-merriweather">
				Getting started with Stelmart is simple. Follow these steps to start buying or selling steel and polymer products today:
			</p>
			<div className="smallLine"></div>
			<motion.div
				className="steps-row custom-container-side font-inter"
				initial="hidden"
				whileInView="visible"
				viewport={{ once: true, amount: 0.2 }}
			>
				{steps.map((step, index) => (
					<motion.div
						key={index}
						className="step-item"
						variants={index % 2 === 0 ? animationVariants.even : animationVariants.odd}
					>
						<div className="step-icon">
							<div className="smallLine">
								<div className="circle"></div>
								<div className="line"></div>
							</div>
							<div className="inner-circle">
								<img src={step.icon} alt={step.title} className="step-svg-icon" />
							</div>
						</div>
						<p className="step-description font-inter">{step.description}</p>
						<h2 className="step-title">{step.title}</h2>
					</motion.div>
				))}
			</motion.div>
		</div>
	);
};

export default Work;
